/**
 * Available premium features
 *
 * IMPORTANT: If you change a constant value don't forget to update its translation in src/assets/i18n/xx/enums.json
 */
export const ABSORPTION = "absorption";
export const ADVANCED_STOCK = "advanced_stock";
export const CUSTOM_TRANSFER_ORDER = "custom_transfer_order";
export const DEPOSIT_BONUS = "deposit_bonus";
export const IMEI_SEARCH_AND_COLLECT = "imei_search_and_collect";
export const MULTI_PRODUCT_CART = "multi_product_cart";
export const PAYMENT_BONUS = "payment_bonus";
export const REFURB_CONNECTOR = "refurb_connector";
export const SCAN_SEARCHBAR = "scan_searchbar";
export const SFTP_ACCESS = "sftp_access";
export const SCAN_SEARCHBAR_IS_ACTIVE_ON_WEB = "is_active_on_web";
export const SCAN_SEARCHBAR_IS_ACTIVE_ON_STORE = "is_active_on_store";

export const AVAILABLE_PREMIUM_FEATURES = [
  ABSORPTION,
  CUSTOM_TRANSFER_ORDER,
  DEPOSIT_BONUS,
  IMEI_SEARCH_AND_COLLECT,
  MULTI_PRODUCT_CART,
  PAYMENT_BONUS,
  REFURB_CONNECTOR,
  SCAN_SEARCHBAR,
];

export const AVAILABLE_PREMIUM_FEATURES_NOT_CONNECTOR = [
  ABSORPTION,
  CUSTOM_TRANSFER_ORDER,
  IMEI_SEARCH_AND_COLLECT,
  MULTI_PRODUCT_CART,
  PAYMENT_BONUS,
  SFTP_ACCESS,
];
